import React from "react";
import styled from "styled-components";
const Title = styled.div`
  font-family: TiemposHeadlineWeb;
  font-weight: 400;
  font-size: ${({ fontSize = "42px" }) => fontSize};
  width: 80%;
  @media (max-width: 680px) {
    width: 94%;
    margin-bottom: 2rem;
    font-size: 28px;
  }
`;
export default ({ children, fontSize }) => (
  <Title fontSize={fontSize} className="f2 mb3">
    {children}
  </Title>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/service/Title/index.js